// axiosInstance.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.omnidexai.ca', // Set your base URL
  // baseURL: 'http://localhost:3001', // Set your base URL
});


instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/'
    }
    return Promise.reject(error);
  }
);

export default instance;
